import React, { useState, useEffect } from 'react'
import { FormControlLabel, FormLabel, Grid, Radio, RadioGroup, Typography } from '@mui/material'

import { Control, Controller, UseFormRegister } from 'react-hook-form'
import { format } from 'date-fns'
import { ErrorMessage, FormInput } from '../../../../components/styled/uiComponents'
import FileInput from '../../FileInput'

interface Props {
  register: UseFormRegister<any>
  control: Control<any, any>
  getValues: (name?: string) => any
  errors: any
  metaData?: any
  handleChangeDescription: (description: string) => void
}

const ArmyDiscount: React.FC<Props> = ({ register, handleChangeDescription, errors, control }) => {
  const [startDate, setStartDate] = useState<string>('')

  useEffect(() => {
    handleChangeDescription('Jäljennös Jäljennös palvelutodistusesta tai varusmieskortista')
  }, [])

  const handleChangeStartDate = (e: any) => {
    setStartDate(e.target.value)
  }
  const thisYear = () => {
    return new Date().getFullYear()
  }
  const today = format(new Date(), 'yyyy-MM-d')

  return (
    <Grid container>
      <Grid item xs={12}>
        <Grid item xs={12}>
          <Typography variant='h4' color='primary'>
            Varusmies- tai siviilipalvelus
          </Typography>
          <p>
            Varusmies- tai siviilipalveluksessa vähintään puoli vuotta. Vapautettu jäsenmaksusta.
          </p>
        </Grid>

        <Grid item xs={12}>
          <Controller
            name='els_alennusvuosi'
            control={control}
            defaultValue={thisYear()}
            render={({ field: { onChange, value } }) => (
              <RadioGroup onChange={e => onChange(e.target.value)} value={value}>
                <FormControlLabel
                  value={thisYear()}
                  control={<Radio />}
                  label={`Haen alennusta tälle vuodelle (${thisYear()})`}
                />
                <FormControlLabel
                  value={thisYear() + 1}
                  control={<Radio />}
                  label={`Haen alennusta ensi vuodelle (${thisYear() + 1})`}
                />
              </RadioGroup>
            )}
          />
          <ErrorMessage>{errors?.els_alennusvuosi?.message}</ErrorMessage>
        </Grid>

        <div style={{ borderTop: '1px dotted black', paddingTop: '3vh', paddingBottom: '3vh' }}>
          <Typography variant='h6' color='primary'>
            Liitteet
          </Typography>
          <p>
            Jäljennös palvelutodistuksesta tai varusmieskortista. Voit skannata tai ottaa valokuvan
            asiakirjasta.
          </p>
          <FileInput name='attachments' control={control} />
          <ErrorMessage>{errors?.attachments?.message}</ErrorMessage>
        </div>

        <div style={{ borderTop: '1px dotted black', paddingTop: '3vh' }}>
          <Typography variant='h6' color='primary'>
            Jäsenmaksun mahdollinen palautus
          </Typography>
          <Grid item xs={12} md={6}>
            <FormLabel>
              Tilinumero jäsenmaksun mahdollista palautusta varten (IBAN-muodossa)
            </FormLabel>
            <FormInput {...register('bankAccount')} />
            <ErrorMessage>{errors?.bankAccount?.message}</ErrorMessage>
          </Grid>
        </div>
      </Grid>
    </Grid>
  )
}

export default ArmyDiscount
